var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "box",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2841",
    "data-name": "Path 2841",
    d: "M13.1,8.769.48,11.22v9.269a.512.512,0,0,0,.361.488l8.207,2.51a.756.756,0,0,0,.369.019l12.208-2.37a.511.511,0,0,0,.413-.5V11.786a.508.508,0,0,0-.361-.487L13.471,8.788a.773.773,0,0,0-.37-.019",
    transform: "translate(0.741)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2842",
    "data-name": "Path 2842",
    d: "M9.272,24a1.254,1.254,0,0,1-.364-.054L.7,21.436a.985.985,0,0,1-.7-.947V11.22a.481.481,0,0,1,.388-.472L13.009,8.3a1.224,1.224,0,0,1,.6.031l8.208,2.511a.983.983,0,0,1,.7.946v8.849a.993.993,0,0,1-.8.972L9.509,23.978A1.252,1.252,0,0,1,9.272,24M.96,11.615v8.874l8.228,2.539a.29.29,0,0,0,.137.008l12.209-2.371.024-8.879L13.33,9.247a.3.3,0,0,0-.137-.007ZM13.1,8.769h0Z",
    transform: "translate(0.741)",
    fill: "#414143"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2843",
    "data-name": "Path 2843",
    d: "M13.288,8.733.48,11.22V3.28a.509.509,0,0,1,.413-.5L12.681.491a.509.509,0,0,1,.607.5Z",
    transform: "translate(0.741)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2844",
    "data-name": "Path 2844",
    d: "M.48,11.7A.481.481,0,0,1,0,11.22V3.28a.993.993,0,0,1,.8-.972L12.59.02a.976.976,0,0,1,.817.207.984.984,0,0,1,.361.764V8.733a.48.48,0,0,1-.388.471L.572,11.691A.486.486,0,0,1,.48,11.7M12.808.991.985,3.251.962,10.637l11.846-2.3Zm.48,7.742h0Z",
    transform: "translate(0.741)",
    fill: "#414143"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2845",
    "data-name": "Path 2845",
    d: "M8.446,12.528a.48.48,0,0,1-.091-.951L14.94,10.3a.48.48,0,0,1,.184.942L8.539,12.519a.488.488,0,0,1-.093.009",
    transform: "translate(0.741)",
    fill: "#414143"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2846",
    "data-name": "Path 2846",
    d: "M9.231,14.376a.5.5,0,0,1-.141-.021L.34,11.678a.48.48,0,1,1,.281-.917l8.751,2.676a.48.48,0,0,1-.141.939",
    transform: "translate(0.741)",
    fill: "#414143"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2847",
    "data-name": "Path 2847",
    d: "M9.23,23.448V13.9l12.387-2.4",
    transform: "translate(0.741)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2848",
    "data-name": "Path 2848",
    d: "M9.231,23.928a.48.48,0,0,1-.48-.48V13.9a.479.479,0,0,1,.388-.471l12.387-2.406a.48.48,0,0,1,.184.943l-12,2.329v9.157a.48.48,0,0,1-.48.48",
    transform: "translate(0.741)",
    fill: "#414143"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2849",
    "data-name": "Path 2849",
    d: "M12.122,13.343v9.638l7.453-1.448V11.9Z",
    transform: "translate(0.741)",
    fill: "#71ef9e"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2850",
    "data-name": "Path 2850",
    d: "M12.123,23.461a.48.48,0,0,1-.48-.48V13.343a.481.481,0,0,1,.388-.471l7.452-1.447a.472.472,0,0,1,.4.1.481.481,0,0,1,.174.37v9.638a.479.479,0,0,1-.388.471l-7.452,1.447a.486.486,0,0,1-.092.009m.48-9.722V22.4l6.492-1.26v-8.66Z",
    transform: "translate(0.741)",
    fill: "#414143"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.65e56aec10371b7a1eb304a9046e2adc.svg";
export { ForwardRef as ReactComponent };